import { files } from '@/content/files/files.json'

/**
 * Realtime Files state
 */
export const state = () => ({ files: [] })

export const mutations = {
  setFiles(state, files) {
    state.files = files
  },
}

export const getters = {
  // Retrieves a file by ID from the store
  file: state => id => state.files.find(file => file.id === id),
  // Filters out files that are currently unavailable for an EID.  This is generally
  // due to the EID missing a higher tier package, like the "Designer Kit".
  // Note that the RTF declares the included_in as product codes, so we're looping into
  // the packages products
  filesAvailableToEid: state => state.files,
}

export const actions = {
  async fetchFiles({ commit }, pkg) {
    const { data } = await this.$api.get(`/api/v2/files/${pkg}`)

    // Before committing this, we also need to make sure that we load the catalog and filter the files

    // Loop over our API data, merge it with our CMS'd data, send to the store!
    commit(
      'setFiles',
      data.map(file => ({
        ...file,
        ...files.find(({ id }) => id === file.id),
      }))
    )
  },
}
